(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory7Service", ['$ihttp', function ($ihttp) {
        let service = {
            getTextileModelCategory7: function (parms) {
                return $ihttp.post({
                    method: 2695,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2697,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
